module.exports = __webpack_public_path__ + "img/logo.cdd14288.png";